import { render, staticRenderFns } from "./customCounts.vue?vue&type=template&id=bd87198c&scoped=true&"
import script from "./customCounts.vue?vue&type=script&lang=js&"
export * from "./customCounts.vue?vue&type=script&lang=js&"
import style0 from "./customCounts.vue?vue&type=style&index=0&id=bd87198c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd87198c",
  null
  
)

export default component.exports